import api from '@/api';

const resource = 'merenda/composicao-alimento-padrao';

export default {
  criarComposicaoAlimentoPadrao( data ) {
    return api.post( `${resource}`, data );
  },

  editarComposicaoAlimentoPadrao( data ) {
    return api.put( `${resource}/${data.identificadorcomposicaoalimentopadrao}`, data);
  },

  deletarComposicaoAlimentoPadrao( id ) {
    return api.delete(`${resource}/${id}`);
  },

  buscarComposicoesAlimentoPadrao(data) {
    return api.get( `${resource}`,  {
      params: data
    }  );
  }
};
